import 'components/Type';
import React from 'react';
import {Route, Switch} from 'react-router-dom';

import Login from 'containers/Login';
import BookingList from 'containers/BookingList';
import RoomAllocations from 'containers/RoomAllocations';
import DevPlayground from 'containers/DevPlayground';
import LocationsPage from 'containers/Locations';
import FrontDesk from 'containers/FrontDesk';
import StatusPage from 'containers/StatusPage';
import AcceptInvitation from 'containers/AcceptInvitation';
import UserList from 'containers/UserList';
import ForgotPassword from 'containers/ForgotPassword';
import ForgotPasswordSet from 'containers/ForgotPasswordSet';
import MyTeams from 'containers/MyTeams';
import Webhooks from 'containers/Webhooks';
import QuickSearch from 'containers/QuickSearch';
import Occupancy from 'containers/Occupancy';
import InvoiceReporting from 'containers/InvoiceReporting';
import RevenueReporting from 'containers/RevenueReporting';
import LookerRevenueReporting from 'containers/LookerRevenueReporting';
import PageNotFound from 'containers/PageNotFound';
import BookingSetList from 'containers/BookingSetList';
import Availability from 'containers/Availability';
import BookingSetDetail from 'containers/BookingSetDetail';
import MemberDetails from 'containers/MemberDetails';
import NotesList from 'containers/NotesList';
import PaymentsList from 'containers/PaymentsList';
import MemberList from 'containers/MemberList';
import BookingDetail from 'containers/BookingDetail';
import BookingTracker from 'containers/BookingTracker';
import OneOffChargeReasonsList from 'containers/OneOffChargeReasonsList';
import CreditNotesList from 'containers/CreditNotesList';
import RoomPurposes from 'containers/RoomPurposes';

import {
  ROUTER_LOGIN_URL,
  LOCATION_LIST_URL,
  BOOKING_LIST_URL,
  BOOKING_DETAIL_URL,
  BOOKING_TRACKER_URL,
  ALLOCATIONS_URL,
  DEV_PLAYGROUND_URL,
  FRONT_DESK_URL,
  STATUS_PAGE_URL,
  ACCEPT_INVITATION,
  USER_LIST_URL,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SET,
  MY_TEAMS,
  WEBHOOKS_URL,
  QUICK_SEARCH_URL,
  OCCUPANCY_REPORTING_URL,
  INVOICE_REPORTING_URL,
  REVENUE_REPORTING_URL,
  LOOKER_REPORTING_URL,
  PAGE_NOT_FOUND_KEY,
  BOOKING_SET_LIST_URL,
  AVAILABILITY_URL,
  BOOKING_SET_DETAIL_URL,
  MEMBER_DETAILS_URL,
  NOTES_LIST_URL,
  PAYMENTS_LIST_URL,
  MEMBER_LIST_URL,
  ONE_OFF_CHARGE_REASONS_URL,
  CREDIT_NOTES_LIST_URL,
  ROOM_PURPOSES_URL
} from './urls';

const Routes = () => {
  return (
    <Switch>
      <Route exact path={ROUTER_LOGIN_URL} component={Login} />
      <Route exact path={LOCATION_LIST_URL} component={LocationsPage} />
      <Route exact path={BOOKING_LIST_URL} component={BookingList} />
      <Route exact path={ALLOCATIONS_URL} component={RoomAllocations} />
      <Route exact path={FRONT_DESK_URL} component={FrontDesk} />
      <Route exact path={DEV_PLAYGROUND_URL} component={DevPlayground} />
      <Route exact path={STATUS_PAGE_URL} component={StatusPage} />
      <Route exact path={ACCEPT_INVITATION} component={AcceptInvitation} />
      <Route exact path={USER_LIST_URL} component={UserList} />
      <Route exact path={FORGOT_PASSWORD} component={ForgotPassword} />
      <Route exact path={FORGOT_PASSWORD_SET} component={ForgotPasswordSet} />
      <Route exact path={MY_TEAMS} component={MyTeams} />
      <Route exact path={WEBHOOKS_URL} component={Webhooks} />
      <Route exact path={QUICK_SEARCH_URL} component={QuickSearch} />
      <Route exact path={OCCUPANCY_REPORTING_URL} component={Occupancy} />
      <Route exact path={INVOICE_REPORTING_URL} component={InvoiceReporting} />
      <Route exact path={REVENUE_REPORTING_URL} component={RevenueReporting} />
      <Route
        exact
        path={LOOKER_REPORTING_URL}
        component={LookerRevenueReporting}
      />
      <Route exact path={BOOKING_SET_LIST_URL} component={BookingSetList} />
      <Route exact path={AVAILABILITY_URL} component={Availability} />
      <Route exact path={BOOKING_SET_DETAIL_URL} component={BookingSetDetail} />
      <Route exact path={MEMBER_DETAILS_URL} component={MemberDetails} />
      <Route exact path={NOTES_LIST_URL} component={NotesList} />
      <Route exact path={PAYMENTS_LIST_URL} component={PaymentsList} />
      <Route exact path={MEMBER_LIST_URL} component={MemberList} />
      <Route exact path={BOOKING_DETAIL_URL} component={BookingDetail} />
      <Route exact path={BOOKING_TRACKER_URL} component={BookingTracker} />
      <Route exact path={CREDIT_NOTES_LIST_URL} component={CreditNotesList} />
      <Route
        exact
        path={ONE_OFF_CHARGE_REASONS_URL}
        component={OneOffChargeReasonsList}
      />
      <Route exact path={ROOM_PURPOSES_URL} component={RoomPurposes} />
      <Route key={PAGE_NOT_FOUND_KEY} component={PageNotFound} />
    </Switch>
  );
};

export default Routes;
